import { ApiProperty } from '@nestjs/swagger';
import { ProdPayMasterSheetInterface } from '../interfaces/prod-pay-master-sheet.interface';
import { Exclude, Expose } from 'class-transformer';
import { JobPhaseContractorHistoryDto } from '../../job-phase-contractor-history/dto/job-phase-contractor-history.dto';
import { BuilderInterface } from 'src/modules/builder/interfaces/builder.interface';
import { BuildingInterface } from 'src/modules/building/interfaces/building.interface';
import { JobInterface } from 'src/modules/job/interfaces/job.interface';
import { PhaseInterface } from 'src/modules/phase/interfaces/phase.interface';
import { RegionInterface } from 'src/modules/region/interfaces/region.interface';
import { SubdivisionInterface } from 'src/modules/subdivision/interfaces/subdivision.interface';
import { PhaseStructureTypeEnum } from '../../phase/enums/phase-structure-type.enum';
import { ContractorResourceTypeEnum } from '../../contractor/enums/contractor-resource-type.enum';
import { SubdivisionOverrideTypeEnum } from '../../subdivision/enums/subdivision-override-type.enum';
import { IsEnum } from 'class-validator';

@Exclude()
export class ProdPayMasterSheetDto implements ProdPayMasterSheetInterface {
  @Expose()
  phaseStructureType!: PhaseStructureTypeEnum;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  hasTrim!: boolean;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  hasInteriorOptions!: boolean;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  interiorOptionCost?: number | undefined;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  hasExteriorOptions!: boolean;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  exteriorOptionCost?: number | undefined;

  @ApiProperty({
    title: 'Has Trim Options',
  })
  @Expose()
  hasTrimOptions!: boolean;

  @ApiProperty({
    title: 'Trim Option Cost',
    nullable: true,
  })
  @Expose()
  trimOptionCost?: number | undefined;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  totalSquareFootage?: number | undefined;
  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  regionGarageCostFixed!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  regionDwHangingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  regionDwFinishingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  regionDwSprayingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  subdivisionGarageCostFixed!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  subdivisionDwHangingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  subdivisionDwFinishingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  subdivisionDwSprayingCostPerBoard!: number | null;
  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  subdivisionOverrideRegionCostPerBoard!: boolean | null;

  job?: JobInterface | undefined;
  building?: BuildingInterface | undefined;
  region?: RegionInterface | undefined;
  subdivision?: SubdivisionInterface | undefined;
  builder?: BuilderInterface | undefined;
  phase?: PhaseInterface | undefined;
  //
  // Job phase fields
  //
  @ApiProperty({
    title: 'Job Phase ID',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Date Approved',
  })
  @Expose()
  dateApproved!: Date;

  @ApiProperty({
    title: 'Job ID',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Supervisor Full Name',
  })
  @Expose()
  supervisorFullNames!: string;

  //
  // Job Fields
  //

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string | null;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  jobHasNotes!: boolean;

  @ApiProperty({
    title: 'Job Has Special Payment',
  })
  @Expose()
  jobHasSpecialPayment!: boolean;

  //
  // Phase Type Fields
  //

  @ApiProperty({
    title: 'Job Phase Type Id',
  })
  @Expose()
  phaseId!: string;

  @ApiProperty({
    title: 'Job Phase Type Name',
  })
  @Expose()
  phaseName!: string;

  //
  // Building Fields
  //

  @ApiProperty({
    title: 'Building ID',
    nullable: true,
  })
  @Expose()
  buildingId!: string | null;

  @ApiProperty({
    title: 'Building Number',
    nullable: true,
  })
  @Expose()
  buildingNumber!: string | null;

  //
  // Region fields
  //

  @ApiProperty({
    title: 'Region Id',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    title: 'Region Name',
  })
  @Expose()
  regionName!: string;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  //
  // Builder fields
  //

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Model Id',
  })
  @Expose()
  modelId!: string;

  @ApiProperty({
    title: 'Model Name',
  })
  @Expose()
  modelName!: string;

  //
  // Job Phase Fields
  //

  @ApiProperty({
    title: 'Paid?',
    type: 'boolean',
    description:
      'Paid state of the most recent Payment Status History entry, false when the job phase has none.',
  })
  @Expose()
  isPaid!: boolean;

  @ApiProperty({
    title: 'Date Paid',
    type: 'string',
    format: 'date-time',
    nullable: true,
    description:
      'Timestamp of the most recent Payment Status History entry when it is Paid, null when the job phase is Unpaid or has no history.',
  })
  @Expose()
  datePaid!: Date | null;

  @ApiProperty({
    title: 'Payment Status History count',
    type: 'number',
    nullable: true,
    description: 'Number of Payment Status History entries for the job phase.',
  })
  @Expose()
  countPaidHistory!: number | null;

  @ApiProperty({
    title: 'houseMarked?',
  })
  @Expose()
  houseMarked!: boolean;

  @ApiProperty({
    type: () => [JobPhaseContractorHistoryDto],
    title: 'Job Phase Contractor Histories',
  })
  @Expose()
  jobPhaseContractorHistories?: JobPhaseContractorHistoryDto[];

  //
  // Contractor fields
  //

  @ApiProperty({
    title: 'Contractor Id',
  })
  @Expose()
  contractorId!: string;

  @ApiProperty({
    title: 'Contractor Name',
  })
  @Expose()
  contractorName!: string;

  @ApiProperty({
    title: 'Contractor Corporation',
  })
  @Expose()
  contractorCorporation!: string;

  @ApiProperty({
    title: 'Contractor Notes',
  })
  @Expose()
  contractorNotes!: string;

  @ApiProperty({
    title: 'Contractor has notes',
  })
  @Expose()
  contractorHasNotes!: boolean;

  @ApiProperty({
    title: 'Initial Contractor Id',
  })
  @Expose()
  initialContractorId!: string;

  @ApiProperty({
    title: 'Contractor Name',
  })
  @Expose()
  initialContractorName!: string;

  @ApiProperty({
    title: 'Region High Ceiling Per Board',
  })
  @Expose()
  regionHighCeilingPerBoard!: number | null;

  @ApiProperty({
    title: 'Region Screw Inspection Per Board',
  })
  @Expose()
  regionScrewInspectionPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision HighCeiling Per Board',
  })
  @Expose()
  subdivisionHighCeilingPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Screw Inspection Per Board',
  })
  @Expose()
  subdivisionScrewInspectionPerBoard!: number | null;

  //
  // Board receipt fields
  //

  @ApiProperty({
    title: 'Total Payable Boards',
  })
  @Expose()
  payableBoardsTotal!: number;

  @ApiProperty({
    title: 'Total Supervisor Count',
  })
  @Expose()
  payableBoardsReceiptTotal!: number | null;

  @ApiProperty({ title: 'Region Dwp Hanging Cost Per Board', nullable: true })
  @Expose()
  regionDwpHangingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Region Dwp Finish Level 4 Cost Per Board',
    nullable: true,
  })
  @Expose()
  regionDwpFinishCostPerBoard!: number | null;

  @ApiProperty({ title: 'Region Dwp Prime Cost Per Board', nullable: true })
  @Expose()
  regionDwpPrimeCostPerBoard!: number | null;

  @ApiProperty({ title: 'Region Dwp Bump 1 Cost Per Board', nullable: true })
  @Expose()
  regionDwpBump1CostPerBoard!: number | null;

  @ApiProperty({ title: 'Region Dwp Rough Trim Cost Per Sqft', nullable: true })
  @Expose()
  regionDwpTrim1CostPerSqft!: number | null;

  @ApiProperty({
    title: 'Region Dwp Interior Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  regionDwpInteriorPaintCostPerSqft!: number | null;

  @ApiProperty({ title: 'Region Dwp Bump 2 Cost Per Board', nullable: true })
  @Expose()
  regionDwpBump2CostPerBoard!: number | null;

  @ApiProperty({
    title: 'Region Dwp Final Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  regionDwpFinalPaintCostPerSqft!: number | null;

  @ApiProperty({ title: 'Region Dwp Bump 3 Cost Per Board', nullable: true })
  @Expose()
  regionDwpBump3CostPerBoard!: number | null;

  @ApiProperty({
    title: 'Region Dwp Paint Bump 1 Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  regionDwpCMBluetapeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Region Dwp Paint Bump 2 Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  regionDwpFinalBluetapeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Region Dwp Final Trim Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  regionDwpTrim2CostPerSqft!: number | null;

  @ApiProperty({ title: 'Region Interior Options Percentage', nullable: true })
  @Expose()
  regionInteriorOptionsPercentage!: number | null;

  @ApiProperty({ title: 'Region Exterior Options Percentage', nullable: true })
  @Expose()
  regionExteriorOptionsPercentage!: number | null;

  @ApiProperty({ title: 'Region Dwp Prime Cost Per Sqft', nullable: true })
  @Expose()
  regionDwpPrimeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Hanging Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpHangingCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Finish Level 4 Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpFinishCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Prime Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpPrimeCostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Bump 1 Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpBump1CostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Rough Trim Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpTrim1CostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Interior Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpInteriorPaintCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Bump 2 Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpBump2CostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Final Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpFinalPaintCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Bump 3 Cost Per Board',
    nullable: true,
  })
  @Expose()
  subdivisionDwpBump3CostPerBoard!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Paint Bump 1 Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpCMBluetapeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Paint Bump 2 Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpFinalBluetapeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Dwp Final Trim Paint Cost Per Sqft',
    nullable: true,
  })
  @Expose()
  subdivisionDwpTrim2CostPerSqft!: number | null;

  @ApiProperty({
    title: 'Subdivision Interior Options Percentage',
    nullable: true,
  })
  @Expose()
  subdivisionInteriorOptionsPercentage!: number | null;

  @ApiProperty({
    title: 'Subdivision Exterior Options Percentage',
    nullable: true,
  })
  @Expose()
  subdivisionExteriorOptionsPercentage!: number | null;

  @ApiProperty({
    title: 'Region Trim Option Percentage',
    nullable: true,
  })
  @Expose()
  regionTrimOptionPercentage!: number | null;

  @ApiProperty({
    title: 'Subdivision Trim Option Percentage',
    nullable: true,
  })
  @Expose()
  subdivisionTrimOptionPercentage!: number | null;

  @ApiProperty({ title: 'Has Exterior Paint' })
  @Expose()
  hasExteriorPaint!: boolean;

  @ApiProperty({ title: 'Exterior Siding/Paint Amount', nullable: true })
  @Expose()
  exteriorSidingPaintAmount?: number | null;

  @ApiProperty({ title: 'Region Exterior One Percentage', nullable: true })
  @Expose()
  regionExteriorOnePercentage?: number | null;

  @ApiProperty({ title: 'Region Exterior Two Percentage', nullable: true })
  @Expose()
  regionExteriorTwoPercentage?: number | null;

  @ApiProperty({
    title: 'Subdivision Exterior One Percentage',
    nullable: true,
  })
  @Expose()
  subdivisionExteriorOnePercentage?: number | null;

  @ApiProperty({
    title: 'Subdivision Exterior Two Percentage',
    nullable: true,
  })
  @Expose()
  subdivisionExteriorTwoPercentage?: number | null;

  @ApiProperty({ title: 'Subdivision Dwp Prime Cost Per Sqft', nullable: true })
  @Expose()
  subdivisionDwpPrimeCostPerSqft!: number | null;

  @ApiProperty({
    title: 'Interior Options Finished Job Phase ID',
    nullable: true,
  })
  @Expose()
  interiorOptionsFinishedJobPhaseId?: string;

  @ApiProperty({
    title: 'Exterior Options Finished Job Phase ID',
    nullable: true,
  })
  @Expose()
  exteriorOptionsFinishedJobPhaseId?: string;

  @ApiProperty({
    title: 'Interior Options Finished',
    nullable: true,
  })
  @Expose()
  interiorOptionsFinished?: boolean | null;

  @ApiProperty({
    title: 'Exterior Options Finished',
    nullable: true,
  })
  @Expose()
  exteriorOptionsFinished?: boolean | null;

  @ApiProperty({
    title: 'Trim Options Finished',
    nullable: true,
  })
  @Expose()
  trimOptionsFinished?: boolean | null;

  @ApiProperty({
    title: 'Trim Options Finished Job Phase ID',
    nullable: true,
  })
  @Expose()
  trimOptionsFinishedJobPhaseId?: string;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  highCeiling!: boolean;

  @ApiProperty({
    title: 'Job Has Notes',
  })
  @Expose()
  screwInspection!: boolean;

  @ApiProperty({
    type: 'enum',
    enum: ContractorResourceTypeEnum,
    nullable: true,
    title: 'Resource Type',
    description: 'The resource type of this Phase',
  })
  @IsEnum(ContractorResourceTypeEnum)
  @Expose()
  resourceType!: ContractorResourceTypeEnum | null;

  @ApiProperty({
    type: 'enum',
    enum: SubdivisionOverrideTypeEnum,
    nullable: true,
    title: 'Override Type',
    description: 'The override type for subdivision cost calculation',
  })
  @IsEnum(SubdivisionOverrideTypeEnum)
  @Expose()
  overrideType!: SubdivisionOverrideTypeEnum | null;
}
